import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
} from 'react-bootstrap';

import Alert from 'components/ui/Alert';
import ErrorAlert from 'components/ui/ErrorAlert';
import TripsActionCreator from '../../../../actions/TripsActionCreator';
import TripFormStore from '../../../../stores/TripFormStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class GenerateTripModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    orderId: PropTypes.string.isRequired,
    shipments: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    })),
  };

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      formStatus: {
        pending: false,
        completed: false,
        success: false,
        error: null,
      },
    };
  }

  componentDidMount() {
    TripFormStore.addChangeListener(this.handleTripFormChange);
    TripFormStore.addTripGeneratedEventListener(this.handleTripGeneratedEvent);
  }

  componentWillUnmount() {
    TripFormStore.removeChangeListener(this.handleTripFormChange);
    TripFormStore.removeTripGeneratedEventListener(this.handleTripGeneratedEvent);
  }

  handleClose = () => this.props.onClose();

  handleTripFormChange = () => {
    const tripContext = TripFormStore.getTripContext();

    const {
      formStatus,
    } = tripContext;

    this.setState({
      formStatus,
    });
  }

  handleTripGeneratedEvent = () => {
    setTimeout(() => this.props.onClose(), 500);
  }

  handleTripGeneratedEvent = () => {
    const tripContext = TripFormStore.getTripContext();

    const {
      formStatus,
    } = tripContext;

    this.setState({
      formStatus,
    }, () => {
      const {
        formStatus: {
          completed,
          success,
        },
      } = this.state;

      if (completed && success) {
        setTimeout(() => this.props.onClose(), 500);
      }
    });
  }

  handleNameChange = e => this.setState({
    name: e.target.value,
  });

  handleGenerateTrip = () => TripsActionCreator.generateTrip(this.transformPayload());

  handleCloseSaveErrorAlert = () => this.setState((prevState) => {
    const {
      formStatus: currentFormStatus,
    } = prevState;

    const formStatus = {
      ...currentFormStatus,
      completed: false,
      error: null,
    };
    return {
      formStatus,
    };
  });

  handleCloseSuccessAlert = () => this.setState((prevState) => {
    const {
      formStatus: currentFormStatus,
    } = prevState;

    const formStatus = {
      ...currentFormStatus,
      completed: false,
    };

    return {
      formStatus,
    };
  });

  submitDisabled() {
    const {
      shipments,
    } = this.props;

    const {
      name,
    } = this.state;

    return shipments.length === 0 || !name;
  }

  transformPayload() {
    const {
      shipments,
      orderId,
    } = this.props;

    const {
      name,
    } = this.state;

    const mappedShipments = shipments.reduce(
      (request, shipment) => {
        const type = shipment.status === 'Staging' ? 'shipments_staging' : 'shipments';

        if (!request.hasOwnProperty(type)) {
          request[type] = [shipment._id];
        } else {
          request[type] = request[type].concat(shipment._id);
        }
        return request;
      },
      {},
    );

    return {
      name,
      orderId,
      ...mappedShipments,
    };
  }

  render() {
    const {
      show,
      t,
    } = this.props;
    const {
      formStatus,
    } = this.state;

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('GENERATE_TRIP')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section className="mb-4">
            <label className="form-label mb-2 block">
              {t('WHATS_TRIP_NAME')}
            </label>
            <input
              type="text"
              placeholder={t('TRIP_NAME')}
              value={this.state.name}
              onChange={this.handleNameChange}
              className="form-field"
            />
          </section>
        </Modal.Body>

        <Modal.Footer>
          <div className="flex justify-end mb-2">
            <button
              className="button button-green mr-2"
              onClick={this.handleGenerateTrip}
              disabled={this.submitDisabled()}
            >
              {t('GENERATE_TRIP')}
            </button>
            <button
              className="button button-secondary"
              onClick={this.handleClose}
            >
              {titleize(t('CANCEL'))}
            </button>
          </div>
          {formStatus.completed && !formStatus.success && (
            <div className="w-full">
              <ErrorAlert
                title={t('ERROR_WHILE_GERERATING_TRIP')}
                canClose
                onClose={this.handleCloseSaveErrorAlert}
              />
            </div>
          )}
          {formStatus.completed && formStatus.success && (
            <div className="w-full">
              <Alert
                title={t('TRIP_GERNERATED_SUCCSSFULLY')}
                type="success"
                canClose
                onClose={this.handleCloseSuccessAlert}
              />
            </div>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default withTranslation()(GenerateTripModal); 